/**
 * We've chosen to pull this out to run unit tests and to ensure that our
 * regex is correct.
 * @param value i18n string to interpolate
 * @returns Array of matches or null
 */
export default function matchI18nStringInterpolation(value: string): RegExpMatchArray | null {
  return value.match(/{{\s*(.*?)\s*}}/g);
}
